import * as React from "react"

const Avatar: React.FC<{alt: string, className: string}> = ({alt, className}) => (
  <svg
    className={className}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={alt}
  >
    <circle cx={28} cy={28} r={27} fill="#F1F5F9" />
    <path
      d="M17.142 16.202A20.907 20.907 0 0 0 32.2 22.6a20.94 20.94 0 0 0 8.28-1.704m4.111 28.406a23.39 23.39 0 0 0-33.182 0M40.6 22.6c0 6.959-5.641 12.6-12.6 12.6s-12.6-5.641-12.6-12.6S21.041 10 28 10s12.6 5.641 12.6 12.6ZM55 28c0 14.912-12.088 27-27 27S1 42.912 1 28 13.088 1 28 1s27 12.088 27 27Z"
      stroke="#C3CCD9"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Avatar